
export class ArrowPathItem {
	public id: number;
	public text: string;
	public tooltip: string = '';
	public active: boolean = false;
	public color: string = 'blue'; // or red
}
